export function getEnrollmentUrl(enrollmentCode: string) {
    return `https://www.raiseright.com/enroll/${enrollmentCode}`;
    // return `https://raiseright.onelink.me/Gei8?af_web_dp=https%3A%2F%2Fwww.raiseright.com%2Fenroll%3FenrollCode%3D${enrollmentCode}&af_xp=custom&pid=dashboard&c=dashboard&deep_link_value=EnrollmentCode%3Fcode%3D${enrollmentCode}&af_dp=swsapp%3A%2F%2FEnrollmentCode%3Fcode%3D${enrollmentCode}`;
}

export function getEnrollmentUrlQR(enrollmentCode: string) {
    return `https://www.raiseright.com/enroll/${enrollmentCode}`;
    // return `https://raiseright.onelink.me/Gei8?af_web_dp=https%3A%2F%2Fwww.raiseright.com%2Fenroll%3FenrollCode%3D${enrollmentCode}&af_xp=custom&pid=qrcode&c=qrcode&deep_link_value=EnrollmentCode%3Fcode%3D${enrollmentCode}&af_dp=swsapp%3A%2F%2FEnrollmentCode%3Fcode%3D${enrollmentCode}`;
}
